(function ($, site, prodcat, MantleCarousel) {
  Drupal.behaviors.sppproductlayout = {
    attach: function (context) {
      var $sppLayouts = $('.js-spp-content', context);

      $sppLayouts.each(function () {
        var $spp = $(this);
        var $imageFull = $('.js-product-full__image', $spp);
        /* Product image change on swatch hover
           note this works on a delay when restoring the original images so that
           we don't switch back original image when moving mouse between swatches. */
        var restoreDefaultTimeout = null;

        // eslint-disable-next-line complexity
        $spp.on('shadePickerShade:hover-in', function (e, skuBaseId) {
          var sku = prodcat.data.getSku(skuBaseId);
          var $images = $('.product-full__carousel__slide.slick-current img', $imageFull);
          var $carousel = $('.js-spp-carousel', $imageFull);
          var currentIndex = $carousel.slick('slickCurrentSlide');
          var newImage = null;
          var altIndex = currentIndex - 1;

          e.preventDefault();
          window.clearTimeout(restoreDefaultTimeout);

          /* Only do this when we are a carousel. This happens for a short
             period before the carousels initialize. */
          if (!MantleCarousel.isCarousel($carousel)) {
            return;
          }

          if (currentIndex === 0) {
            newImage = sku.LARGE_IMAGE[0];
          }

          if (currentIndex > 0 && sku.LARGE_ALT_IMAGES) {
            if (altIndex < sku.LARGE_ALT_IMAGES.length) {
              newImage = sku.LARGE_ALT_IMAGES[altIndex];
            }
          }

          if (!newImage) {
            return;
          }

          // Store the original image if we don't have a data-src
          $images.each(function () {
            var $image = $(this);

            $image.attr('src', newImage);
          });
        });

        $spp.on('shadePickerShade:hover-out', function () {
          var restoreDefaultImages = function () {
            var $images = $('.product-full__carousel__slide.slick-current img', $imageFull);

            $images.each(function () {
              var $image = $(this);
              // Prefer the attr since data is cached.
              var originalSource = $image.attr('data-src');

              if (originalSource) {
                $image.attr('src', originalSource);
              }
            });
          };

          window.clearTimeout(restoreDefaultTimeout);
          restoreDefaultTimeout = window.setTimeout(restoreDefaultImages, 100);
        });

        $spp.on('click', '.js-play', function (e) {
          var $play = $(this);
          var $module = $play.closest('.js-product-video');
          var provider = $module.data('video-provider');
          var opts = {
            provider: provider,
            openOverlay: false,
            $content: $module
          };

          if (provider === 'youtube') {
            opts.youTubeId = $module.data('youtube-id');
          } else if (provider === 'vimeo') {
            opts.vimeoId = $module.data('vimeo-id');
          } else if (provider === 'zentrick') {
            opts.zentrickId = $module.data('zentrick-id');
          } else if (provider === 'html5') {
            opts.$content = $module.find('video').wrap('<div />').parent().html();
          }

          e.preventDefault();
          site.videos.open(opts);

          return false;
        });
      });
    }
  };
})(jQuery, window.site || {}, window.prodcat || {}, window.MantleCarousel || {});
